<template>
  <div>
    <div class="d-flex" id="wrapper" :class="{ toggled: isSidebar }">
      <app-sidebar></app-sidebar>
      <div id="page-content-wrapper" style="width:100%">
        <i class="material-icons" id="menu-toggle" @click="isSidebar =  !isSidebar">view_headline</i>
        <app-navbar></app-navbar>
        <div class="container-fluid mt-5">
          <div class="col-sm-12">
            <vs-breadcrumb
              align="left"
              :items="
                  [
                    {title: 'You are here: '},
                    {
                      title: 'Dashboard',
                      url: '/#/dashboard/communicationOfficer/home'
                    },
                    
                    {
                      title: 'Uploads --> '+this.trainingDetail.title,
                      active: true
                    }
                  ]"
            ></vs-breadcrumb>
            <div class="heading mt-3">
              <h3 class="text-secondary">
                Upload
                <small>(Images, Videos, Certificates, Weblinks)</small>
              </h3>
            </div>

            <div class="row mt-5">
              <div class="col-lg-8">
                <h3 class="text-blue">{{trainingDetail.title}}</h3>
              </div>
            </div>

            <div class="row mt-3">
              <div class="col-sm-4">
                <label class="mr-2 font-weight-bold">Subprogram</label>
                {{trainingDetail.subprogram.title}}
              </div>
              <div class="col-sm-4">
                <label class="mr-2 font-weight-bold">Project</label>
                {{trainingDetail.project.title}}
              </div>

              <div class="col-sm-4" v-if="trainingDetail.programofficer != null">
                <label class="mr-2 font-weight-bold">Program Officer</label>
                {{trainingDetail.programofficer.name}}
              </div>
              <div class="col-sm-4" v-else>
                <label class="mr-2 font-weight-bold">Program Officer</label>
                Not assigned yet
              </div>
            </div>
            <div class="row mt-3">
             <div class="col-sm-4" v-if="trainingDetail.advisor != null">
                <label class="mr-2 font-weight-bold">Advisor</label>
                {{trainingDetail.advisor.name}}
              </div>
              <div class="col-sm-4" v-else>
                <label class="mr-2 font-weight-bold">Advisor</label>
                Not assigned yet
              </div>
              <div class="col-sm-4" v-if="trainingDetail.startdate">
                <label class="mr-2 font-weight-bold">Start Date</label>
                {{trainingDetail.startdate}}
              </div>
              <div class="col-sm-4" v-else>
                <label class="mr-2 font-weight-bold">Start Date</label>
                Not defined yet
              </div>
              <div class="col-sm-4" v-if="trainingDetail.enddate">
                <label class="mr-2 font-weight-bold">End Date</label>
                {{trainingDetail.enddate}}
              </div>
              <div class="col-sm-4" v-else>
                <label class="mr-2 font-weight-bold">End Date</label>
                Not defined yet
              </div>
            </div>
            <div class="row mt-5">
              <div class="col-lg-8">
                <h5 class="text-blue">Please upload the following</h5>
              </div>
            </div>
            <div class="row mt-3">
              <div class="col-sm-4">
                <p class="mr-2 text-danger" v-if="trainingDetail.is_image_commofficer == 0">
                  <label  class="font-weight-bold">Image(s): </label> Pending
                </p>
                <p class="mr-2 text-success" v-else>
                  <label class="font-weight-bold">Image(s):</label> Uploaded
                </p>
              </div>
              <div class="col-sm-4">
                <p class="mr-2 text-danger" v-if="trainingDetail.is_video_commofficer == 0">
                  <label  class="font-weight-bold">Video(s): </label> Pending
                </p>
                <p class="mr-2 text-success" v-else>
                  <label class="font-weight-bold">Video(s):</label> Uploaded
                </p>
              </div>
              <div class="col-sm-4">
                <p class="mr-2 text-danger" v-if="trainingDetail.is_certificate_commofficer == 0">
                  <label  class="font-weight-bold">Certificate(s): </label> Pending
                </p>
                <p class="mr-2 text-success" v-else>
                  <label class="font-weight-bold">Certificate(s):</label> Uploaded <br> <span class="mt-0">(To upload more certificates, select certificate from file type and choose Trainee one by one from dropdwon below)</span>
                </p>
              </div>
            </div>

            <div class="modelx mt-5">
              <!-- Pre Training -->
              <b-card v-if="isForm == true" style="border: 1px dotted #07a7e14f;">
                <form @submit.prevent="uploadTrainingMaterial" enctype="multipart/form-data">
                  <div class="form-group form-row mb-0">
                  <div class="row col-sm-12">
                  <div class="col-sm-4 col-md-4 col-lg-3">
                    <label style="color: #07a7e19c !important;">
                      Title
                      <span style="color:rgba(255, 0, 0, 1);">*</span>
                    </label>
                    <div>
                      <input
                        style="line-height: 3;height: 36px;box-shadow: none !important;calc(1.3em + 0.75rem + 2px)"
                        type="text"
                        class="form-control"
                        id="inputtext"
                        v-model="materialTitle"
                        placeholder="Enter title"
                      />
                    </div>
                  </div>
                  <div class="col-sm-4 col-md-4 col-lg-3">
                    <label style="color: #07a7e19c !important;">
                      File Type
                      <span style="color:rgba(255, 0, 0, 1);">*</span>
                    </label>
                     <selectize
                        id="select-state"
                        v-model="upload_material"
                        :searchable="true"
                        :settings="fileTypesettings"
                        >

                        <option :value="1">Image</option>
                        <option :value="2">Video</option>
                        <option :value="3">certificate</option>
                        <option :value="4">Link</option>
                      </selectize>
                  </div>
                  
                  <div class="col-sm-6 col-md-6 col-lg-5" v-if="fileDiv == true">
                    <label style="color: #07a7e19c !important;">
                      Upload
                      <span style="color:rgba(255, 0, 0, 1);">*</span>
                    </label>
                    <b-form-file
                      ref="file"
                      type="file"
                      name="filetoupload"
                      v-on:change="handleFileUpload($event.target.files)"
                      :state="Boolean(file)"
                      placeholder="Choose a file..."
                      drop-placeholder="Drop file here..."
                    ></b-form-file>
                  </div>
                  <div class="col-sm-6 col-md-6 col-lg-5" v-if="this.upload_material == 3">
                    <div class="form-group">
                      <label style="color: #07a7e19c !important;" for="first">Trainee(s) <span style="color:rgba(255, 0, 0, 1);">*</span></label>
                      <selectize
                        id="select-state"
                        v-model="selectedTrainee"
                        :searchable="true"
                        :settings="traineesettings"
                      >
                        <option
                          v-for="(trainee, index) in traineeArr"
                          :key="index"
                          :value="trainee.id"
                          >{{ trainee.name }}</option
                        >
                      </selectize>
                    </div>
                  </div>
                  <div class="col-sm-6 col-md-6 col-lg-5" v-if="linkDiv == true">
                    <label style="color: #07a7e19c !important;">Link</label>
                    <input
                      style="line-height: 3;height: 36px;box-shadow: none !important;calc(1.3em + 0.75rem + 2px)"
                      type="text"
                      v-model="materialink"
                      class="form-control"
                      id="inputtext"
                      placeholder="Enter full URL of a file, image or video"
                    />
                  </div>
                  <div class="col-sm-4 col-md-4 col-lg-1 mt-3">
                    <b-button
                      type="submit"
                      class="save-btn d-flex justify-content-left"
                      variant="primary"
                    >Save</b-button>
                  </div>
                  </div>
                </div>
                </form>
              </b-card>
              <b-card v-if="isEditForm == true" style="border: 1px dotted #07a7e14f;">
                <form @submit.prevent="updateTrainingMaterial" enctype="multipart/form-data">
                  <div class="form-group form-row mb-0">
                  <div class="row col-sm-12">
                  <div class="col-sm-4 col-md-4 col-lg-3">
                    <label style="color: #07a7e19c !important;">
                      Title
                      <span style="color:rgba(255, 0, 0, 1);">*</span>
                    </label>
                    <div>
                      <input
                        style="line-height: 3;height: 36px;box-shadow: none !important;calc(1.3em + 0.75rem + 2px)"
                        type="text"
                        class="form-control"
                        id="inputtext"
                        v-model="materialTitle"
                        placeholder="Enter title"
                      />
                    </div>
                  </div>
                  <div class="col-sm-4 col-md-4 col-lg-3">
                    <label style="color: #07a7e19c !important;">
                      File Type
                      <span style="color:rgba(255, 0, 0, 1);">*</span>
                    </label>
                    <input
                        style="line-height: 3;height: 36px;box-shadow: none !important;calc(1.3em + 0.75rem + 2px)"
                        type="text"
                        class="form-control"
                        id="inputtext"
                        v-model="upload_material_text"
                        disabled
                      />
                  </div>
                  
                  <div class="col-sm-6 col-md-6 col-lg-5" v-if="fileDiv == true">
                    <label style="color: #07a7e19c !important;">
                      Upload
                      <span style="color:rgba(255, 0, 0, 1);">*</span>
                    </label>
                    <b-form-file
                      ref="file"
                      type="file"
                      name="filetoupload"
                      v-on:change="handleFileUpload($event.target.files)"
                      :state="Boolean(file)"
                      placeholder="Choose a file..."
                      drop-placeholder="Drop file here..."
                    ></b-form-file>
                    <span v-if="this.uploadedFileShow != ''">
                    Uploaded File: <a :href="BASEPATHDYNAMIC+'/'+this.uploadedFileShow" target="_blank">
                      <u>To View File Click Here</u>
                    </a>
                    <p class="text-danger">(If you want to upload new file, then choose file OR leave as it is.)</p>
                    </span>
                  </div>
                  <div class="col-sm-6 col-md-6 col-lg-5" v-if="this.upload_material == 3">
                    <div class="form-group">
                      <label style="color: #07a7e19c !important;" for="first">Trainee(s) <span style="color:rgba(255, 0, 0, 1);">*</span></label>
                      <selectize
                        id="select-state"
                        v-model="selectedTrainee"
                        :searchable="true"
                        :settings="traineesettings"
                      >
                        <option
                          v-for="(trainee, index) in traineeArr"
                          :key="index"
                          :value="trainee.id"
                          >{{ trainee.name }}</option
                        >
                      </selectize>
                    </div>
                  </div>
                  <div class="col-sm-6 col-md-6 col-lg-5" v-if="linkDiv == true">
                    <label style="color: #07a7e19c !important;">Link</label>
                    <input
                      style="line-height: 3;height: 36px;box-shadow: none !important;calc(1.3em + 0.75rem + 2px)"
                      type="text"
                      v-model="materialink"
                      class="form-control"
                      id="inputtext"
                      placeholder="Enter full URL of a file, image or video"
                    />
                  </div>
                  <input type="hidden" v-model="materialEditId">
                  <div class="row col-sm-12">
                  <div class="col-sm-4 col-md-4 col-lg-1 mt-1">
                    <b-button
                    pill
                      type="submit"
                      class="save-btn justify-content-left"
                      variant="primary"
                    >Update</b-button>
                  </div>
                  <div class="col-sm-4 col-md-4 col-lg-1 mt-1">
                    <b-button
                    pill
                      type="submit"
                      class="save-btn justify-content-left"
                      variant="primary"
                      @click="editRecordCancel"
                    >Cancel</b-button>
                  </div>
                  </div>
                  </div>
                </div>
                </form>
              </b-card>
              <div class="col-sm-12 p-0 mt-3">
                <!-- new form popup starts -->
                <b-card>
                  <div class="form-group">
                    <div class="row">
                      <div class="col-sm-12">
                        <div class="table-responsive">
                          <table class="table table-stripped">
                            <thead>
                              <tr>
                                <th>Title</th>
                                <th>File Type</th>
                                <th>Download</th>
                                <th>Uploaded At</th>
                                <th>Action</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr v-for="(material,index) in materialArr" v-bind:key="index">
                                <td>{{material.title}}</td>
                                <td>{{material.fileType}}</td>
                                <td v-if="material.fileType != 'Weblink'">
                                  <a
                                    :href="BASEPATHDYNAMIC+'/'+material.uploadfile"
                                    target="_blank"
                                  >
                                    <i
                                      class="material-icons"
                                      style="font-size:28px;color:#4285f4"
                                    >get_app</i>
                                  </a>
                                </td>
                                <td v-else>
                                  <a :href="'//' + material.link" target="_blank">
                                    <i class="material-icons" style="font-size:28px;color:#4285f4">link</i>
                                  </a>
                                </td>

                                <td>{{material.createdAt | formatDate}}</td>
                                <td>
                                  <a @click="editRecord(material.id)">
                                    <vs-icon
                                      class="mr-4"
                                      icon="edit"
                                      style="color:#007bff;font-size:20px;font-weight:600;cursor: pointer;"
                                    ></vs-icon>
                                  </a>
                                  <a @click="deleteRecord(material.id)">
                                    <vs-icon
                                      class="mr-1"
                                      icon="delete"
                                      style="color:#ff0000c7;font-size:20px;font-weight:600;cursor: pointer;"
                                    ></vs-icon>
                                  </a>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </b-card>
                <!-- new form popup ends -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Navbar from "./Navbar";
import Sidebar from "./Sidebar";
import Selectize from "vue2-selectize";

import "bootstrap/dist/css/bootstrap.css";

// Import date picker css
import "pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css";
import axios from "axios";
axios.defaults.headers.post["Content-Type"] = "multipart/form-data";

export default {
  data: () => ({
    BASEPATHDYNAMIC: localStorage.getItem("BASE_PATH"),
    isSidebar: false,
    items: [],
    isForm: true,
    isEditForm: false,
    filetoupload: null,
    file: "",
    materialink: "",
    selectedTrainee: "",
    imagesource: "",
    fileTypesettings: {
      searchField: ["text"],
      placeholder: "Upload type"
    },
    traineesettings: {
      searchField: ["text"],
      placeholder: "Select trainee here"
    },
    uploadedFile: "",
    materialArr: [],
    trainingCode: "",
    traineeArr: [],
    trainingDetail: "",
    fileDiv: true,
    linkDiv: false,
    traineeDiv: false,
    upload_material: '',
    upload_material_text: '',
    trainingId: "",
    materialTitle: "",
    materialEditId: "",
    uploadedFileShow: "",
  }),
  watch: {
    upload_material(val){
      if(val == 3){
        this.fileDiv = true;
        this.linkDiv = false;
        this.file = "";
        this.materialink = "";
        this.showTrainee();
      } else if(val == 4){
        this.linkDiv = true;
        this.fileDiv = false;
        this.file = "";
        this.selectedTrainee = "";
        this.filetoupload = null;
      } else if(val == 1 || val == 2){
        this.fileDiv = true;
        this.file = "";
        this.linkDiv = false;
        this.materialink = "";
        this.selectedTrainee = "";
      }
    },
    selectedTrainee(val){
      this.checkTraineeCertificate(val);
    }
  },
  mounted() {
    this.trainingCode = this.$route.query.training;
    this.trainingMaterial();
  },
  components: {
    Selectize,
    "app-navbar": Navbar,
    "app-sidebar": Sidebar
  },
  methods: {
    // this will check if trainee has already uploaded certificate
    checkTraineeCertificate(trainId){
      if(this.materialArr.some(item => item.trainee_certificate_id == trainId) && this.isEditForm != true){
        this.selectedTrainee = "";
        this.$toasted.global.errorMsg("Certificate has already been uploaded for this Trainee. Select another Trainee.");
        return true;
      } else {
        return false;
      }
    },
    trainingMaterial: function trainingMaterial() {
      this.openLoading();
      axios
        .get(
          localStorage.getItem("BASE_PATH") +
            "/comm/officer/training/materials/"+this.trainingCode+"/get"
        ,{
              headers:{
                Authorization:localStorage.getItem("token"),
              }
            }
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
            
          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
          this.closeLoading();
          this.trainingDetail = response.data.training;
          this.trainingId = response.data.training.id;
          this.materialArr = response.data.materials;
        });
    },
    // this will show all trainees related to this training
    showTrainee: function showTrainee(){
      this.openLoading();
      axios.get(localStorage.getItem("BASE_PATH") + "/trainees/training/"+this.trainingId+"/get",{
              headers:{
                Authorization:localStorage.getItem("token"),
              }
            }
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
            
          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
        this.closeLoading();
        this.traineeArr = response.data;
      });
    },
    openLoading() {
      this.$vs.loading({
        type: "material"
      });
    },
    closeLoading() {
      this.$vs.loading.close();
    },
    editRecordCancel(){
      this.isEditForm = false;
      this.isForm = true;
      this.resetForm();
    },
    editRecord(id) {
      this.isForm = false;
      this.isEditForm = true;
      this.file = "";
      this.materialTitle = "";
      this.upload_material = "";
      this.materialink = "";
      this.selectedTrainee = "";
      this.materialEditId = "";
      this.upload_material_text = "";
      this.uploadedFileShow = "";
      this.openLoading();
      axios
        .get(
          localStorage.getItem("BASE_PATH") +
            "/communication-officer/traing_material/"+id+"/edit"
        ,{
              headers:{
                Authorization:localStorage.getItem("token"),
              }
            }
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
            
          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
          this.closeLoading();
          if (response) {
            this.materialEditId = response.data.id;
            this.materialTitle = response.data.title;

            if(response.data.fileType == 'Image'){
              this.upload_material = 1;
              this.upload_material_text = "Image"
              this.uploadedFileShow = response.data.uploadfile;
            } else if(response.data.fileType == 'Video'){
              this.upload_material = 2;
              this.upload_material_text = "Video"
              this.uploadedFileShow = response.data.uploadfile;
            } else if(response.data.fileType == 'Certificate'){
              this.upload_material = 3;
              this.upload_material_text = "Certificate"
              this.uploadedFileShow = response.data.uploadfile;
              this.selectedTrainee = response.data.trainee_certificate_id;
            } else if(response.data.fileType == 'Weblink'){
              this.upload_material = 4;
              this.upload_material_text = "Weblink"
              this.materialink = response.data.link;
            } else {
              this.upload_material = '';
            }
            
          }
        });
    },
    deleteRecord(id) {
      // alert("ID '" +id+ "' is being deleted.");
      this.$bvModal
        .msgBoxConfirm("Please confirm that you want to delete?", {
          title: "Please Confirm",
          size: "sm",
          buttonSize: "sm",
          okVariant: "danger",
          okTitle: "Delete",
          cancelTitle: "Cancel",
          footerClass: "p-2",
          hideHeaderClose: false,
          centered: true
        })
        .then(value => {
          if (value == true) {
            this.openLoading();
            axios
              .post(
                localStorage.getItem("BASE_PATH") + "/uploadmaterial/delete",
                {
                  id: id
                }
              ,{
              headers:{
                Authorization:localStorage.getItem("token"),
              }
            }
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
            
          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
                this.closeLoading();
                if (response.data.success) {
                  this.$toasted.global.successMsg("Record has been deleted successfully!");
                  this.trainingMaterial();
                } else if (response.data.error) {
                  throw response.data.error;
                }
              })
              .catch(error => {
                this.$toasted.global.errorMsg(error);
              });
          }
        });
    },
    toastSuccess(msg) {
      this.$bvToast.toast(msg, {
        title: "Success",
        autoHideDelay: 10000,
        variant: "success",
        solid: true
      });
    },
    toastError(msg) {
      this.$bvToast.toast(msg, {
        title: "Error",
        autoHideDelay: 10000,
        variant: "danger",
        solid: true
      });
    },
    
    uploadTrainingMaterial(e) {
      e.preventDefault();
      this.inValid = [];
      let self = this;
      if (this.materialTitle == "") {
        this.inValid.push("Title is required.");
      }
      if (this.file == "" && (this.upload_material == 1 || this.upload_material == 2 || this.upload_material == 3)) {
        this.inValid.push("Please select IMAGE, VIDEO or CERTIFICATE to upload.");
      }
      if(this.materialink == "" && this.upload_material == 4){
        this.inValid.push("Enter full link and try again.");
      }
      if(!this.selectedTrainee && this.upload_material == 3){
        this.inValid.push("Select trainee and try again please!");
      }
      for (var i = 0; i < this.inValid.length; i++) {
        this.$toasted.global.errorMsg(this.inValid[i]);
      }
      if (!this.inValid.length) {
        // define -this- outside axios methods because -this- inside axios refers to the axios object, not the vue component:
        let formData = new FormData();
        formData.append("file", this.file);
        formData.append(
          "user_id",
          JSON.parse(localStorage.getItem("currentUser")).id
        );
        formData.append("materialTitle", this.materialTitle);
        formData.append("fileType", this.upload_material);
        formData.append("training_id", this.trainingId);
        formData.append("link", this.materialink);
        formData.append("traineeId", this.selectedTrainee);
        this.openLoading();
        axios
          .post(
            localStorage.getItem("BASE_PATH") +
              "/communication-officer/upload/trainingmaterial",
            formData,
            {
              headers: {
                "Content-Type": "multipart/form-data"
              }
            },{
              headers:{
                Authorization:localStorage.getItem("token"),
              }
            }
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
            
          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
            this.closeLoading();
            if (response.data.success) {
              self.$toasted.global.successMsg("Record has been added successfully!");
              self.resetForm();
              self.trainingMaterial();
            } else if (response.data.error) {
              throw response.data.error;
            }
          })
          .catch(error => {
            self.$toasted.global.errorMsg(error);
          });
      }
    },
    updateTrainingMaterial(e) {
      e.preventDefault();
      this.inValid = [];
      let self = this;
      if (this.materialTitle == "") {
        this.inValid.push("Title is required.");
      }
      if(this.materialink == "" && this.upload_material == 4){
        this.inValid.push("Enter full link and try again.");
      }
      if(!this.selectedTrainee && this.upload_material == 3){
        this.inValid.push("Select trainee and try again please!");
      }
      for (var i = 0; i < this.inValid.length; i++) {
        this.$toasted.global.errorMsg(this.inValid[i]);
      }
      if (!this.inValid.length) {
        // define -this- outside axios methods because -this- inside axios refers to the axios object, not the vue component:
        let formData = new FormData();
        formData.append("file", this.file);
        formData.append(
          "user_id",
          JSON.parse(localStorage.getItem("currentUser")).id
        );
        formData.append("materialTitle", this.materialTitle);
        formData.append("fileType", this.upload_material);
        formData.append("training_id", this.trainingId);
        formData.append("link", this.materialink);
        formData.append("traineeId", this.selectedTrainee);
        formData.append("materialEditId", this.materialEditId);
        this.openLoading();
        axios
          .post(
            localStorage.getItem("BASE_PATH") +
              "/communication-officer/training_material/update",
            formData,
            {
              headers: {
                "Content-Type": "multipart/form-data"
              }
            },{
              headers:{
                Authorization:localStorage.getItem("token"),
              }
            }
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
            
          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
            this.closeLoading();
            if (response.data.success) {
              self.$toasted.global.successMsg("Record has been updated successfully!");
              self.resetForm();
              self.editRecordCancel();
              self.trainingMaterial();
            } else if (response.data.error) {
              throw response.data.error;
            }
          })
          .catch(error => {
            self.$toasted.global.errorMsg(error);
          });
      }
    },
    handleFileUpload(fileList) {
      this.file = fileList[0];
      var FileSizeMb = this.file.size / Math.pow(1024, 2);
      if (this.upload_material == "3") {
        if (this.file.type != "application/pdf" && this.file.type != "image/jpeg" && this.file.type != "image/jpg" && this.file.type != "image/png") {
          this.$toasted.global.errorMsg("Please Select PDF file or jpeg,jpg,png format.");
          this.file = "";
          this.filetoupload = null;
        }
        if (FileSizeMb > 5) {
          this.$toasted.global.errorMsg("File size is greater than 1 MB");
          this.file = "";
          this.filetoupload = null;
        }
      } else if (this.upload_material == 2) {
        if (this.file.type != "video/mp4" && this.file.type != "") {
          this.$toasted.global.errorMsg("Please Select Video file");
          this.file = "";
          this.filetoupload = null;
        }
        if (FileSizeMb > 15) {
          this.$toasted.global.errorMsg("File size is greater than 15 MB");
          this.file = "";
          this.filetoupload = null;
        }
      } else if (this.upload_material == 1) {
        if (
          this.file.type != "image/jpeg" &&
          this.file.type != "image/jpg" &&
          this.file.type != "image/png"
        ) {
          this.$toasted.global.errorMsg("Please Select Image with jpeg,jpg,png format");
          this.file = "";
          this.filetoupload = null;
        }
        if (FileSizeMb > 5) {
          this.$toasted.global.errorMsg("File size is greater than 5 MB");
          this.file = "";
          this.filetoupload = null;
        }
      }
    },
    resetForm() {
      this.materialTitle = "";
      this.upload_material = "";
      this.file = "";
      this.filetoupload = "";
      this.materialink = "";
      this.selectedTrainee = "";
      this.materialEditId = "";
    },
    showForm() {
      this.isForm = false;
      this.isFormData = true;
    },
    successUpload() {
      this.$vs.notify({
        color: "success",
        title: "Upload Success",
        text: "Files have been Uploaded, consectetur"
      });
    }
  }
};
</script>
<style scoped>
#menu-toggle {
  display: none;
}

@media (max-width: 768px) {
  #menu-toggle {
    display: block;
  }
}
.was-validated .custom-file-input:invalid ~ .custom-file-label,
.custom-file-input.is-invalid ~ .custom-file-label {
  border-color: #cecece;
}

.f-500 {
  font-weight: 500;
}
.dblock {
  display: block !important;
}
.input-color {
  margin-bottom: 10px;
  position: relative;
  display: block;
}
.myNavbar {
  color: rgb(255, 255, 255);
}
.dflex {
  display: flex;
}
.otherMaterial_palceholder {
  margin-top: 16px;
  background: #dedede;
  padding: 10px 0px 10px 0px;
  text-align: center;
}
.vd-crd {
  margin-top: 25px;
}
.fcenter {
  justify-content: center;
  align-items: center;
}
.pleft-5 {
  margin-left: 5px;
}
.selectExample {
  margin: 10px;
}
.con-select-example {
  display: flex;
  align-items: center;
  justify-content: center;
}
.con-select .vs-select {
  width: 100%;
}
@media (max-width: 550px) {
  .con-select {
    flex-direction: column;
  }
  .con-select .vs-select {
    width: 100%;
  }
}

.form-row {
  padding: 8px;
  color: #1465a3;
  border: 1px dotted #07a7e14f;
  margin-left: 0px !important;
  margin-right: 0px !important;
}

.field {
  width: 100%;
  text-transform: capitalize;
  border-bottom: 2px solid #d0d0d0;
  border-top: none !important;
  border-left: none !important;
  border-right: none !important;
  box-shadow: none !important;
  border-radius: 0 !important;
  transition: all 0.2s ease-in-out 0.2s;
  -webkit-transition: all 0.2s ease-in-out 0.2s;
  -moz-transition: all 0.2s ease-in-out 0.2s;
}
.sub-frm-title {
  padding: 5px;
  background-color: #fff;
  margin-top: -25px;
  text-align: center;
  color: rgba(7, 167, 225, 0.61);
}
/* overide css of vuesax */
.vs-con-input-label {
  width: 100% !important;
}
.vs-con-input-label.is-label-placeholder {
  margin-top: 8px !important;
}
.frm-title {
  text-align: center;
  padding: 10px;
  color: #009ad2;
  /* border-bottom: 2px solid #009ad2; */
}
.save-btn {
  box-shadow: none;
  border-color: rgba(7, 167, 225, 0.61);
  background-color: rgba(7, 167, 225, 0.61);
  float: right;
  margin: 10px 0px;
}
.add-locations-btn {
  box-shadow: none;
  border-color: rgba(7, 167, 225, 0.61);
  background-color: rgba(7, 167, 225, 0.61);
  margin: 10px 0px;
}
.btn-primary:not(:disabled):not(.disabled):active,
.btn-primary:not(:disabled):not(.disabled).active,
.show > .btn-primary.dropdown-toggle {
  color: #fff;
  border-color: rgba(7, 167, 225, 0.61);
  background-color: rgba(7, 167, 225, 0.61);
}

.new-training {
  padding-right: 10px;
}
.title-text {
  margin-bottom: 0px;
}
.selectize-control.multi .selectize-input > div {
  background: rgba(7, 167, 225, 0.61);
  color: #333333;
}
.con-select {
  font-size: 0.85rem !important;
}
.selectize-input.items.not-full.has-options.has-items {
  font-size: 0.85rem !important;
}

/* Floating label css starts */
/****  floating-Lable style start ****/
.floating-label {
  position: relative;
  margin-bottom: 5px;
}
.floating-input,
.floating-select {
  font-size: 14px;
  padding: 4px 30px 4px 5px;
  display: block;
  width: 100%;
  height: 36px;
  box-shadow: none !important;
  /* background-color: transparent; */
  border: none;
  border: 1px solid #ccc;
}

.floating-input:focus,
.floating-select:focus {
  outline: none;
  border: 2px solid rgba(7, 167, 225, 0.61);
}

label.lbl-label {
  color: #ccc;
  font-size: 14px;
  font-weight: normal;
  position: absolute;
  pointer-events: none;
  left: 5px;
  top: 6px;
  transition: 0.2s ease all;
  -moz-transition: 0.2s ease all;
  -webkit-transition: 0.2s ease all;
}

.floating-input:focus ~ label.lbl-label,
.floating-input:not(:placeholder-shown) ~ label.lbl-label {
  background-color: #f9f9f9;
  /* background-color: #fff; */
  top: -12px;
  left: 10px;
  font-size: 14px;
  color: rgba(7, 167, 225, 0.61);
  padding: 0px 5px;
}

.floating-select:focus ~ llabel.lbl-label,
.floating-select:not([value=""]):valid ~ label.lbl-label {
  top: -18px;
  font-size: 14px;
  color: #5264ae;
}

/* active state */
.floating-input:focus ~ .bar:before,
.floating-input:focus ~ .bar:after,
.floating-select:focus ~ .bar:before,
.floating-select:focus ~ .bar:after {
  width: 50%;
}

*,
*:before,
*:after {
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
}

/* highlighter */
/* .highlight {
  position: absolute;
  height: 50%;
  width: 100%;
  top: 15%;
  left: 0;
  pointer-events: none;
  opacity: 0.5;
} */

/* active state */
.floating-input:focus ~ .highlight,
.floating-select:focus ~ .highlight {
  -webkit-animation: inputHighlighter 0.3s ease;
  -moz-animation: inputHighlighter 0.3s ease;
  animation: inputHighlighter 0.3s ease;
}

/* animation */
@-webkit-keyframes inputHighlighter {
  from {
    background: #5264ae;
  }
  to {
    width: 0;
    background: transparent;
  }
}
@-moz-keyframes inputHighlighter {
  from {
    background: #5264ae;
  }
  to {
    width: 0;
    background: transparent;
  }
}
@keyframes inputHighlighter {
  from {
    background: #5264ae;
  }
  to {
    width: 0;
    background: transparent;
  }
}

.vs-popup--background {
  opacity: 0.3 !important;
}
.con-img-upload .img-upload {
  width: 150px !important;
}
.add-btn {
  font-size: 25px;
  color: rgba(7, 167, 225, 0.61);
  cursor: pointer;
}
.delete-btn {
  font-size: 25px;
  color: rgba(255, 0, 0, 0.78);
  cursor: pointer;
}

th {
  border-bottom: none !important;
}
.text-blue {
  color: #00a4ea;
}
</style>


